import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Core } from "@faire/design-tokens";
import { useZustandLocation } from "@faire/retailer-visitor-shared/app/_lib/routing/useZustandLocation";
import { HeaderContainer } from "@faire/retailer-visitor-shared/components/Header/styled";
import { home } from "@faire/retailer-visitor-shared/paths/index";
import { useStrictLocalization } from "@faire/web--source/common/localization";
import { Button } from "@faire/web--source/slate/Button";
import { ArrowRight } from "@faire/web--source/slate/icons/Arrow";
import { Row } from "@faire/web--source/slate/Layout";
import { FaireLogo } from "@faire/web--source/slate/logos/FaireLogo";
import { getSpacing, Spacer } from "@faire/web--source/slate/spacing";
import { StrictLocalMsg } from "@faire/web--source/ui/lib/localization";
import { Link } from "@faire/web--source/ui/LinkAnchor";
import { removeLocaleFromUrl } from "@faire/web--source/ui/routing/util";
import careersPath from "@faire/web-api--source/routes/careers";
import belongingPath from "@faire/web-api--source/routes/careers/belonging-at-faire";
import jobOpeningsPath from "@faire/web-api--source/routes/careers/openings";
import React, { useMemo } from "react";
import styled, { css } from "styled-components";
export var HeaderCareersDesktop = function() {
    var _useZustandLocation = useZustandLocation(function(state) {
        return state.pathname;
    }), pathnameWithMaybeLocale = _useZustandLocation.pathname;
    var pathname = useMemo(function() {
        return removeLocaleFromUrl(pathnameWithMaybeLocale);
    }, [
        pathnameWithMaybeLocale
    ]);
    var isOnOpeningsPage = pathname === jobOpeningsPath();
    var links = useLinks();
    return /*#__PURE__*/ _jsx(StyledHeaderContainer, {
        children: /*#__PURE__*/ _jsxs(FullWidthRow, {
            children: [
                /*#__PURE__*/ _jsxs(Row, {
                    align: "center",
                    children: [
                        /*#__PURE__*/ _jsx(Spacer, {
                            width: "8x"
                        }),
                        /*#__PURE__*/ _jsx(Link, {
                            to: home(),
                            children: /*#__PURE__*/ _jsx(FaireLogo, {})
                        })
                    ]
                }),
                /*#__PURE__*/ _jsxs(Row, {
                    align: "center",
                    justify: "flex-end",
                    children: [
                        links.map(function(link, index) {
                            return /*#__PURE__*/ _jsxs(React.Fragment, {
                                children: [
                                    index ? /*#__PURE__*/ _jsx(Spacer, {
                                        width: "4x"
                                    }) : null,
                                    index < links.length - 1 || isOnOpeningsPage ? /*#__PURE__*/ _jsx(NoUnderlineButton, {
                                        $active: pathname === link.path,
                                        variant: "tertiary",
                                        linkTo: link.path,
                                        children: link.label
                                    }) : null
                                ]
                            }, link.label);
                        }),
                        isOnOpeningsPage ? /*#__PURE__*/ _jsx(Spacer, {
                            width: 118
                        }) : /*#__PURE__*/ _jsxs(_Fragment, {
                            children: [
                                /*#__PURE__*/ _jsx(SetWidthCTAButton, {
                                    linkTo: jobOpeningsPath(),
                                    children: /*#__PURE__*/ _jsxs(SignUpButtonContent, {
                                        children: [
                                            /*#__PURE__*/ _jsx(StrictLocalMsg, {
                                                id: "yF3MJe",
                                                defaultMessage: [
                                                    {
                                                        type: 0,
                                                        value: "All Job Openings"
                                                    }
                                                ]
                                            }),
                                            /*#__PURE__*/ _jsx(StyledArrowRight, {})
                                        ]
                                    })
                                }),
                                /*#__PURE__*/ _jsx(Spacer, {
                                    width: "8x"
                                })
                            ]
                        })
                    ]
                })
            ]
        })
    });
};
var useLinks = function() {
    var strictLocalize = useStrictLocalization().strictLocalize;
    return [
        {
            path: careersPath(),
            label: strictLocalize({
                id: "kVS3QG",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Life at Faire"
                    }
                ]
            })
        },
        {
            path: belongingPath(),
            label: strictLocalize({
                id: "usVZBZ",
                defaultMessage: [
                    {
                        type: 0,
                        value: "Belonging at Faire"
                    }
                ]
            })
        },
        {
            path: jobOpeningsPath(),
            label: strictLocalize({
                id: "+l5Tmz",
                defaultMessage: [
                    {
                        type: 0,
                        value: "All Job Openings"
                    }
                ]
            })
        }
    ];
};
var StyledArrowRight = styled(ArrowRight).withConfig({
    componentId: "sc-2a31af32-0"
})([
    "opacity:0;transition:0.5s ease;position:absolute;top:0;bottom:0;margin:auto 0;right:2px;"
]);
var SignUpButtonContent = styled.span.withConfig({
    componentId: "sc-2a31af32-1"
})([
    "transition:0.5s ease;position:relative;padding:0 10px;"
]);
var CTAButton = styled(Button).withConfig({
    componentId: "sc-2a31af32-2"
})([
    "width:fit-content;min-width:220px;"
]);
var StyledCTAButton = styled(CTAButton).withConfig({
    componentId: "sc-2a31af32-3"
})([
    "",
    " &:hover{",
    "{padding:0 20px 0 0;}",
    "{opacity:1;right:0;}}"
], function(props) {
    return props.$isSecondary ? css([
        "border:none;"
    ]) : "";
}, SignUpButtonContent, StyledArrowRight);
var NoUnderlineButton = styled(Button).withConfig({
    componentId: "sc-2a31af32-4"
})([
    "border-bottom:",
    " solid ",
    ";text-decoration:none;&:hover{text-decoration:none;}"
], function(props) {
    return props.$active ? "1px " : "0px";
}, Core.border.default);
var FullWidthRow = styled(Row).attrs({
    justify: "space-between"
}).withConfig({
    componentId: "sc-2a31af32-5"
})([
    "width:100%;"
]);
var StyledHeaderContainer = styled(HeaderContainer).withConfig({
    componentId: "sc-2a31af32-6"
})([
    "height:",
    ";flex-direction:row;"
], getSpacing("8x"));
export var SetWidthCTAButton = styled(StyledCTAButton).withConfig({
    componentId: "sc-2a31af32-7"
})([
    "padding:0px ",
    ";min-width:auto;height:",
    ";"
], getSpacing("2x"), getSpacing("5x"));
